import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";

const PieChartCard = () => {
  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="text-lg font-bold text-navy-700 dark:text-white">
            Your Pie Chart
          </h4>
        </div>

        <div className="mb-6 flex items-center justify-center">
          <select className="mb-3 mr-2 flex items-center justify-center text-sm font-bold text-gray-600 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
            <option value="weekly">Weekly</option>
          </select>
        </div>
      </div>

      <div className="mb-auto flex h-[220px] w-full items-center justify-center">
        <PieChart options={pieChartOptions} series={pieChartData} />
      </div>
      <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-brand-500" />
            <p className="ml-1 text-sm font-normal text-gray-600">Your Files</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
            63%
          </p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
            <p className="ml-1 text-sm font-normal text-gray-600">System</p>
          </div>
          <p className="mt-px text-xl font-bold bg-navy-700 dark:text-white">
            25%
          </p>
        </div>
      </div>

      <div className="flex justify-center gap-4 mt-4">
        {/* AI Links */}
        <a href="https://www.meta.ai/" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Meta-Logo.svg/1024px-Meta-Logo.svg.png" alt="Meta AI" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://chat.openai.com/" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/OpenAI_Logo.svg/512px-OpenAI_Logo.svg.png" alt="Chat GPT" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.google.com/ai/" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%2019_logo.svg/1024px-Google_%2819%29_logo.svg.png" alt="Google AI" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.amd.com/en/ai.html" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/AMD_Logo.svg/800px-AMD_Logo.svg.png" alt="AMD AI" className="w-6 h-6" />
          </button>
        </a>
      </div>
    </Card>
  );
};

export default PieChartCard;
